export default "__VITE_ASSET__Ux1rmCgc__"